import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { usePayrollBundlePageContext } from 'modules/payroll_bundle/components/PayrollBundle'
import PolicyDropdownSelector from 'modules/payroll_bundle/components/PolicyPeriodDashboardContent/RegularCycleSummary/PolicyDropdownSelector'
import PolicyPeriodDropdownSelector from 'modules/payroll_bundle/components/PolicyPeriodDashboardContent/RegularCycleSummary/PolicyPeriodDropdownSelector'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'

const PolicySelectors = () => {
  const session = useCurrentSession()

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const policies = usePolicies()

  const { currentPolicyPeriods, periodIndex, setPeriodId, setCurrentPolicy } = usePolicyPeriods()

  const { selectedPolicy } = usePayrollBundlePageContext()

  const selectedPolicyPeriod = currentPolicyPeriods[periodIndex]

  const handlePolicyChange = (newPolicyId: string) => {
    setCurrentPolicy(newPolicyId)

    track(trackingEvents.payroll.userClicksOnChangePolicySelector, {
      company_id: session.company.id,
      policy_id: newPolicyId,
    })

    navigate(
      navigation.payrollBundle.policy.dashboard.fullPath({
        policyId: newPolicyId,
      })
    )
  }

  const handlePolicyPeriodChange = (newPolicyPeriodId: string) => {
    setPeriodId(newPolicyPeriodId)
  }

  return (
    <Box flexDirection="row" gap={'s16'}>
      {policies.length > 1 && (
        <PolicyDropdownSelector
          selectedPolicy={selectedPolicy}
          policies={policies}
          onPolicyChange={handlePolicyChange}
        />
      )}

      {selectedPolicyPeriod && (
        <PolicyPeriodDropdownSelector
          policyPeriods={currentPolicyPeriods}
          selectedPolicyPeriod={selectedPolicyPeriod}
          onPolicyPeriodChange={handlePolicyPeriodChange}
          policy={selectedPolicy}
        />
      )}
    </Box>
  )
}

export default PolicySelectors
